// @flow
import React from 'react';
import {
  AutoSizer,
  List,
} from 'react-virtualized';
import * as R from 'ramda';

import type {
  Issue,
  GroupByType,
} from 'chronos-types';

import SidebarIssueItem from './SidebarIssueItem';
import SidebarEntityItem from './SidebarEntityItem';
import IssueItemPlaceholder from './IssueItemPlaceholder';
import {
  Wrapper,
  Empty,
} from './styled';


type Props = {
  /**
   * Array of items which were logged
   * */
  data: Array<Issue>,
  /**
   * Set true or false while receive data
   * */
  fetching: boolean,
  /**
   * current group by state
   * */
  groupBy: GroupByType,
  /**
   * Array of selected data.
   * */
  selected: Array<string>,
  /**
   * Function that is called after issue selected.
   * */
  onSelect: (index: number) => {},
  /**
   * Set height of list wrapper(if need).
   * */
  listHeight?: number,
};

type RowRenderProps = {
  /**
   * Unique key within array of rows
   * */
  key: string,
  /**
   * Index of row within collection
   * */
  index: number,
  /**
   * Style object to be applied to row (to position it)
   * */
  style: any,
}

const rowRenderer = ({
  data,
  fetching,
  selected,
  groupBy,
  onSelect,
}) => ({
  key,
  index,
  style,
}: RowRenderProps) => (
  <div
    key={key}
    style={style}
  >
    {
      (!fetching && data[index]) // eslint-disable-line
        ? (groupBy === 'issues'
          ? (
            <SidebarIssueItem
              issue={data[index]}
              selected={selected[groupBy].includes(R.path([index, 'id'], data))}
              onClick={() => onSelect(data[index].id)}
            />
          ) : (
            <SidebarEntityItem
              entity={data[index]}
              selected={selected[groupBy].includes(R.path([index, 'id'], data))}
              onClick={() => {
                onSelect(data[index].id);
              }}
            />
          )
        ) : (
          <IssueItemPlaceholder height={57} />
        )
    }
  </div>
);

const SidebarList = ({
  data,
  groupBy,
  fetching,
  selected,
  onSelect,
  listHeight,
}: Props) => (
  <Wrapper listHeight={listHeight}>
    <AutoSizer>
      {({
        height,
        width,
      }) => (
        <List
          width={width}
          height={height}
          rowCount={
            (
              data.length === 0
              && fetching
            ) ? (
                20
              ) : (
                data.length
              )
          }
          rowHeight={57}
          rowRenderer={(
            rowRenderer({
              data,
              fetching,
              groupBy,
              selected,
              onSelect,
            })
          )}
        />
      )}
    </AutoSizer>
    {
      data.length === 0
      && !fetching
      && (
        <Empty>
          <span>
            No data found matching criteria
          </span>
        </Empty>
      )
    }
  </Wrapper>
);

SidebarList.defaultProps = {
  listHeight: 200,
};

export default SidebarList;
